"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.promise.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.symbol.async-iterator.js");

require("core-js/modules/es.symbol.to-string-tag.js");

require("core-js/modules/es.json.to-string-tag.js");

require("core-js/modules/es.math.to-string-tag.js");

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerSyncStreamer = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.concat.js");

var _utils = require("../utils");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SpeakerSyncStreamer = /*#__PURE__*/function () {
  function SpeakerSyncStreamer(_ref) {
    var _this = this;

    var audioContext = _ref.audioContext,
        config = _ref.config,
        uri = _ref.uri,
        id = _ref.id;

    _classCallCheck(this, SpeakerSyncStreamer);

    _defineProperty(this, "isSafeToPlay", true);

    _defineProperty(this, "playing", false);

    _defineProperty(this, "started", false);

    _defineProperty(this, "alreadyTrying", false);

    _defineProperty(this, "fadingDestination", 0);

    _defineProperty(this, "fading", false);

    this.id = id;
    this.config = config;
    this.uri = (0, _utils.cleanAudioURL)(uri);
    this.loaded = true;
    this.loadedPercentage = 100;
    this.context = audioContext;
    this.audio = new Audio(this.uri);
    this.audio.loop = config.loop || false;
    this.gainNode = audioContext.createGain();
    this.gainNode.gain.value = _utils.NEARLY_ZERO;
    this.audio.crossOrigin = "anonymous";
    this.audio.loop = false;
    this.mediaSource = audioContext.createMediaElementSource(this.audio);
    this.mediaSource.connect(this.gainNode).connect(audioContext.destination);
    this.audio.preload = "auto";
    var that = this;
    ["abort", "ended", "error", "waiting", "stalled", "playing"].forEach(function (e) {
      _this.audio.addEventListener(e, function () {
        that.log(e + " event");

        if (["abort", "ended", "error"].includes(e)) {
          that.playing = false;
        }
      });
    });
    this.log("sync streamer initiaed");
  }

  _createClass(SpeakerSyncStreamer, [{
    key: "play",
    value: function () {
      var _play = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var pausedTime;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.playing) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", true);

              case 2:
                if (!this.alreadyTrying) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                this.alreadyTrying = true;
                _context.prev = 5;

                if (!(this.context.state !== "running")) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return this.context.resume();

              case 9:
                _context.next = 11;
                return this.audio.play();

              case 11:
                this.playing = true;

                if (!this.started) {
                  global._roundwareSpeakerStartedAt = new Date();
                  this.started = true;
                } else if (global._roundwareSpeakerPausedAt instanceof Date && global._roundwareSpeakerStartedAt instanceof Date) {
                  pausedTime = new Date().getTime() - global._roundwareSpeakerPausedAt.getTime();
                  global._roundwareSpeakerStartedAt = new Date(global._roundwareSpeakerStartedAt.getTime() + pausedTime);
                  global._roundwareSpeakerPausedAt = null;
                }

                this.log("Playing...");
                this.alert("Started playing");
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](5);
                console.error(_context.t0);
                this.playing = false;

              case 21:
                _context.prev = 21;
                this.alreadyTrying = false;
                return _context.finish(21);

              case 24:
                return _context.abrupt("return", true);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 17, 21, 24]]);
      }));

      function play() {
        return _play.apply(this, arguments);
      }

      return play;
    }() // for debugging

  }, {
    key: "alert",
    value: function alert() {// if (this.id != 255) return;
      // alert(params);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.playing = false;
      this.audio.pause();
      global._roundwareSpeakerPausedAt = new Date();
    }
  }, {
    key: "replay",
    value: function replay() {
      this.audio.currentTime = 0;
    }
  }, {
    key: "timerStart",
    value: function timerStart() {
      var _this2 = this;

      this.syncTracker = Number(setInterval(function () {
        _this2.trackSync();
      }, this.config.syncCheckInterval || 2500));
      this.play();
    }
  }, {
    key: "timerStop",
    value: function timerStop() {
      this.pause();
      clearInterval(this.syncTracker);
    }
  }, {
    key: "fade",
    value: function fade() {
      var _this3 = this;

      var toVolume = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.fadingDestination;
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
      if (this.fadingDestination == toVolume && this.fading) return;
      this.fadingDestination = toVolume; // already at that volume

      if (Math.abs(this.gainNode.gain.value - this.fadingDestination) < 0.05) return;
      this.log("startng fade ".concat(this.gainNode.gain.value, " -> ").concat(this.fadingDestination));
      this.alert("Fade to ".concat(toVolume));
      this.fading = true;
      var endTime = this.context.currentTime + duration;
      this.gainNode.gain.cancelScheduledValues(0);
      this.gainNode.gain.exponentialRampToValueAtTime(this.fadingDestination || _utils.NEARLY_ZERO, endTime);

      if (this._fadingTimeout) {
        clearTimeout(this._fadingTimeout);
      }

      this._fadingTimeout = setTimeout(function () {
        _this3.fading = false;

        _this3.log("fading ended at volume ".concat(_this3.gainNode.gain.value));
      }, duration * 1000);
    }
  }, {
    key: "fadeOutAndPause",
    value: function fadeOutAndPause() {
      this.fade(0);
    }
  }, {
    key: "log",
    value: function log(string) {
      (0, _utils.speakerLog)("[".concat(this.id, "] ").concat(string));
    }
  }, {
    key: "onLoadingProgress",
    value: function onLoadingProgress(callback) {}
  }, {
    key: "onEnd",
    value: function onEnd(callback) {}
  }, {
    key: "trackSync",
    value: function trackSync() {
      var startedAt = global._roundwareSpeakerStartedAt || new Date();
      if (!(startedAt instanceof Date)) return;
      if (!this.playing) return;
      var elapsedTime = new Date().getTime() - startedAt.getTime();
      if (elapsedTime > this.audio.duration * 1000) return;
      var audioTime = this.audio.currentTime * 1000;
      var difference = elapsedTime - audioTime;
      this.log("Difference: ".concat(difference, " ms; Volume: ").concat(this.gainNode.gain.value));

      if (Math.abs(difference) < (this.config.acceptableDelayMs || 50)) {
        // within acceptable range;
        this.audio.playbackRate = 1;
      } else if (Math.abs(difference) > (this.config.syncCheckInterval || 2500)) {
        // difference is too much; try to seek instead; seek bit ahead to compensate buffering time
        this.log("Seeking to ".concat((elapsedTime + 500) / 1000, "s"));
        this.audio.currentTime = (elapsedTime + 500) / 1000;
        this.audio.playbackRate = 1;
      } else {
        this.audio.playbackRate = 1 + difference / (this.config.syncCheckInterval || 2500);
        this.log("Changing Playback rate to ".concat(this.audio.playbackRate));
      }

      this.fade();
    }
  }]);

  return SpeakerSyncStreamer;
}();

exports.SpeakerSyncStreamer = SpeakerSyncStreamer;